module.exports = __webpack_public_path__ + "img/title02.c7e19845.svg";